export * from './review-rate.component';
